import Wrapper from "../../../layout/Wrapper";
import PolicyComponent from "../../../screens/settings/policies";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "Policies",
	description: "",
};

export default function Policies() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<PolicyComponent />
		</Wrapper>
	);
}